module.exports = __webpack_public_path__ + "static/database_s_img1@2x-c21cd41a024107d400e1f12270fbc9d8.jpg";